import React from 'react';

const SATScoreAnalysis = ({ analysisData }) => {
    // 데이터 유효성 검사 강화
    if (!analysisData) {
        return <div className="text-slate-300">No analysis data available.</div>;
    }

    const categories = Object.entries(analysisData);
    if (categories.length === 0) {
        return <div className="text-slate-300">No analysis data available.</div>;
    }

    // 데이터 구조 유효성 검사
    const isValidData = categories.every(([_, data]) => 
        data && 
        typeof data === 'object' && 
        'Grade' in data && 
        'Reason' in data &&
        typeof data.Reason === 'string'
    );

    if (!isValidData) {
        return <div className="text-slate-300">Preparing analysis data...</div>;
    }

    // Helper function to get color based on grade
    const getGradeColor = (grade) => {
        switch (grade) {
            case 'A':
                return 'text-green-500';
            case 'B':
                return 'text-blue-500';
            case 'C':
                return 'text-yellow-500';
            case 'D':
                return 'text-orange-500';
            case 'F':
                return 'text-red-500';
            default:
                return 'text-gray-500';
        }
    };

    return (
        <div className="w-full max-w-4xl">
            {/* Card Container */}
            <div className="text-slate-100">
                {/* Card Header */}
                <div className="border-b border-[#3b3b3b] px-4 py-2">
                    <h2 className="text-xl font-bold">SAT Score Analysis</h2>
                </div>
                {/* Card Content */}
                <div className="px-4 py-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {categories.map(([category, data], index) => (
                            <div
                                key={index}
                                className="bg-[#2b2b2b] rounded-lg p-4 border border-[#3b3b3b] hover:border-[#87bfff] transition-colors duration-200"
                            >
                                <div className="flex justify-between items-center mb-3">
                                    <h3 className="text-lg font-semibold">{category}</h3>
                                    <span className={`text-xl font-bold ${getGradeColor(data.Grade)}`}>
                                        {data.Grade}
                                    </span>
                                </div>
                                <div
                                    className="text-sm text-slate-300"
                                    dangerouslySetInnerHTML={{
                                        __html: data.Reason ? 
                                            data.Reason.replace(
                                                /\*\*(.*?)\*\*/g,
                                                '<span class="font-bold text-[#87bfff]">$1</span>'
                                            ) : 'Analysis in progress...'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SATScoreAnalysis;